import axios from 'axios';
import variables from 'variables';
import TokenService from './token-service';

const instance = axios.create({
  baseURL: variables.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

instance.interceptors.request.use(
  (config: any) => {
    const token = TokenService.getLocalAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const response = await fetch(`${variables.API_URL}/apiv1/refresh`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer ' + TokenService.getLocalRefreshToken()
            },
            redirect: 'follow',
            referrer: 'no-referrer'
          });
          const { access } = await response.json();
          TokenService.updateLocalAccessToken(access);
          instance.defaults.headers.common.Authorization = `Bearer ${access}`;

          return await instance(originalConfig);
        } catch (_error: any) {
          if (_error?.response && _error?.response.data) {
            return Promise.reject(_error?.response.data);
          }
          return Promise.reject(_error);
        }
      }

      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }

    return Promise.reject(err);
  }
);

export default instance;
